import React, { useState, useMemo } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar, Line, Pie } from 'react-chartjs-2';
import './SeriesCharts.css';
import { CardTaps } from '../../modules/theme/Component/CardTaps';

// Registrar componentes de Chart.js
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const SeriesCharts = ({ xAxisProperties, list, header,onlyGraph=false }) => {
    const [chartType, setChartType] = useState('bar'); // 'bar', 'line', 'pie'

    // Función para formatear labels
    const formatLabel = (label) => {
        if (label === 'SerieName') return '';

        // // Intentamos detectar si es una fecha para formatearla
        // const dateMatch = label.match(/(\d{4})-(\d{2})-\d{2} \/ \d{4}-(\d{2})-\d{2}/);
        // if (dateMatch) {
        //   const year = dateMatch[1];
        //   const month = dateMatch[2];
        //   const monthNames = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        //   const monthName = monthNames[parseInt(month) - 1] || month;
        //   return `${monthName} ${year}`;
        // }

        return label;
    };
    const getColor = (index) => {
        const colors = [
            { background: 'rgba(75, 192, 192, 0.6)', border: 'rgba(75, 192, 192, 1)' },
            { background: 'rgba(255, 99, 132, 0.6)', border: 'rgba(255, 99, 132, 1)' },
            { background: 'rgba(54, 162, 235, 0.6)', border: 'rgba(54, 162, 235, 1)' },
            { background: 'rgba(255, 206, 86, 0.6)', border: 'rgba(255, 206, 86, 1)' },
            { background: 'rgba(153, 102, 255, 0.6)', border: 'rgba(153, 102, 255, 1)' },
            { background: 'rgba(255, 159, 64, 0.6)', border: 'rgba(255, 159, 64, 1)' }
        ];
        return colors[index % colors.length];
    };

    // Preparar datos para UNA ÚNICA gráfica con todas las series
    const chartData = useMemo(() => {
        const categories = xAxisProperties;
        // const categories = xAxisProperties.filter(prop => prop !== 'SerieName');

        // Crear datasets para cada serie
        const datasets = list.map((series, index) => {
            const serieName = series.SerieName;
            const dataValues = categories.map(category => series[category] || 0);

            return {
                label: serieName,
                data: dataValues,
                backgroundColor: getColor(index).background,
                borderColor: getColor(index).border,
                borderWidth: chartType === 'pie' ? 2 : 2,
                fill: chartType === 'line',
                tension: 0.1, // Para líneas suaves
            };
        });

        return {
            labels: categories.map(category => formatLabel(category)),
            datasets: datasets
        };
    }, [xAxisProperties, list, chartType]);

    // Función para obtener colores únicos por serie


    const getChartOptions = () => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'top',
                labels: {
                    font: {
                        size: 12,
                        weight: 'bold'
                    },
                    padding: 20
                }
            },
            title: {
                display: false,
                text: 'Comparación de Series',
                font: {
                    size: 20,
                    weight: 'bold'
                }
            },
            tooltip: {
                mode: 'index',
                intersect: false,
                callbacks: {
                    label: function (context) {
                        const label = context.dataset.label || '';
                        const value = context.parsed.y;
                        return `${label}: ${value}`;
                    }
                }
            }
        },
        scales: chartType !== 'pie' ? {
            x: {
                title: {
                    display: true,
                    text: 'Serie',
                    font: {
                        size: 14,
                        weight: 'bold'
                    }
                },
                ticks: {
                    maxRotation: 45,
                    minRotation: 45
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Valores',
                    font: {
                        size: 14,
                        weight: 'bold'
                    }
                },
                beginAtZero: true,
                ticks: {
                    stepSize: 10
                }
            }
        } : undefined,
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false
        }
    });

    const renderChart = (data, options) => {
        switch (chartType) {
            case 'bar':
                return <Bar data={data} options={options} />;
            case 'line':
                return <Line data={data} options={options} />;
            case 'pie':
                return <Pie data={data} options={options} />;
            default:
                return <Bar data={data} options={options} />;
        }
    };

    const [indexTap, setIndexTap] = useState(0);
    let taps = [
        { id: 0, name: 'Grafica', disable: false },
        { id: 1, name: 'Datos', disable: false }
    ];

    const renderGraph=()=>{
        return(
            <div className="main-chart-container">

                                <div className="chart-card">
                                    <div className="col-md-12">
                                        {header &&
                                            <>
                                                {header}
                                            </>
                                        }
                                    </div>
                                    <div className="chart-controls">

                                        <div className="controls-right">
                                            <div className="chart-type-selector">
                                                <button title='Barras'
                                                    className={`chart-type-btn ${chartType === 'bar' ? 'active' : ''}`}
                                                    onClick={() => setChartType('bar')}
                                                >
                                                    Barras
                                                </button>
                                                <button title='lineas'
                                                    className={`chart-type-btn ${chartType === 'line' ? 'active' : ''}`}
                                                    onClick={() => setChartType('line')}
                                                >
                                                    Lineas
                                                </button>
                                                <button title='pastel'
                                                    className={`chart-type-btn ${chartType === 'pie' ? 'active' : ''}`}
                                                    onClick={() => setChartType('pie')}
                                                >
                                                    Pastel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="chart-wrapper">
                                        {renderChart(chartData, getChartOptions())}
                                    </div>
                                </div>
                            </div>
        )
    }

    return (
        <div className="series-charts-container">

            {onlyGraph ? 
            <>
            {renderGraph()}
            </>
            :
            <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                <div className="row">

                    <div className="col-md-12">
                        {indexTap === 0 &&

                            <>{renderGraph()}</>
                        }
                        {indexTap === 1 &&

                            <div className="data-table-container">
                                <h3>Datos Detallados de Todas las Series</h3>
                                <div className="table-container">
                                    <table className="table  table-striped-columns">
                                        <thead>
                                            <tr>
                                                <th>Registros</th>
                                                {list.map((series, index) => (
                                                    <th key={index} className="series-header">
                                                        {series.SerieName}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {xAxisProperties
                                                .filter(prop => prop !== 'SerieName')
                                                .map((period, periodIndex) => (
                                                    <tr key={periodIndex}>
                                                        <td className="period-cell">{formatLabel(period)}</td>
                                                        {list.map((series, seriesIndex) => (
                                                            <td
                                                                key={seriesIndex}
                                                                className={`value-cell ${series[period] > 0 ? 'has-value' : ''}`}
                                                            >
                                                                {series[period] || 0}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>

            </CardTaps>


        }



        </div>
    );
};

export default SeriesCharts;